module.exports = __webpack_public_path__ + "whiteblack.830fea635bd87d384ff9.png";